import React from 'react';
import classNames from 'classnames';
import './index.less';
/**
 * 可设置最小宽度
 * @param props
 */
const GridContent = (props) => {
    const { children, contentWidth, className: propsClassName, style, prefixCls = 'oss-ui' } = props;
    let className = `${prefixCls}-grid-content`;
    if (contentWidth === 'Fixed') {
        className = `${prefixCls}-grid-content wide`;
    }
    return (<div className={classNames(className, propsClassName)} style={style}>
            <div className={`${prefixCls}-grid-content-children`}>{children}</div>
        </div>);
};
export default GridContent;
